import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import InputField from '../../../components/Input-field/input-field.component';
import Button, { BUTTON_TYPE_CLASSES } from '../../../components/button/button.component';
import { confirm, login, signup } from '../../../Services/auth.service';
import Alert, { ALERT_TYPE } from '../../../components/alert/alert.component';
import moment from 'moment';
import 'moment-timezone';
import { useAuth } from '../../../Contexts/auth.context';
import { CMDiv, CMLink } from '../login/login.styles';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getProfile, login_step_2, loginOrRegister, user_confirmation, user_login_confirm_resendcode, user_profile } from '../../../Services/prod/auth.service';
import { asset_getMyActiveListings } from "../../../Services/prod/asset.service";
import { AutoFixHigh } from '@mui/icons-material';
import Heading from '../../../components/heading/heading.component';
import { Modal } from '@mui/material';
import { CMDivLogin, CMForgotPasswordModal } from './login-confirm.styles';
import CloseButton from '../../../components/close-button/close-button.component';
moment.tz.setDefault("EST");
const initialValues = {
	authCode: ''
}

const loginSchema = Yup.object().shape({
	authCode: Yup.string()
		.required('Verification Code is required'),
});

const ConfirmLogin = ({ open, handleClose, onClose, key2FA, email, ...props }) => {
	const { saveAuth, currentUser, setCurrentUser, saveAuthMapping } = useAuth();
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState('');
	const [userStatus, setUserStatus] = useState('');
	const [disabled, setDisabled] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();
	const searchParams = new URLSearchParams(location.search);
    const returnUrl = searchParams.get('returnUrl');

	const [countdown, setCountdown] = useState(0);
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);

	//console.log(key2FA);

	useEffect(() => {
		let timer;
		if (countdown > 0) {
			timer = setInterval(() => {
				setCountdown(prev => prev - 1);
			}, 1000);
		} else {
			setIsButtonDisabled(false);
		}
		return () => clearInterval(timer);
	}, [countdown]);

	const sendAgain = () => {
		setIsButtonDisabled(true);
		setCountdown(60);

		user_login_confirm_resendcode(key2FA).then(data => {
			if (data && data.isSuccess === true) {
				setUserStatus("Email sent.");
			} else {
				setStatus(data.message);
			}
		}).finally(() => {
			setLoading(false);
		});
	}


	const handleSubmit = async (values, { setStatus }) => {
		setLoading(true);
		setDisabled(true);

		try {
			const loginRes = await login_step_2(key2FA, values.authCode);
			if (loginRes && loginRes.isSuccess) {
				const loginResponse = await loginOrRegister(email, loginRes.user.userId,loginRes.user?.isInfluencer);
				saveAuthMapping(loginResponse?.data)
				const date = new moment(new Date()).add(loginRes.user.expiresIn, 's');
				const expiresAt = new Date(date).getTime();

				let tmpAuth = {
					...loginRes.user,
					expiresAt: expiresAt,
				};
				const profileRes = await getProfile();
				try {
					const profileResponse = await user_profile(loginRes.user.userId);

					if (profileResponse) {
						const userProfile = profileResponse[0];
						localStorage.setItem('isInfluencerProfile',profileRes?.data?.influencer_request)
						tmpAuth = {
							...tmpAuth,
							user_KYCstatus: userProfile.user_KYCstatus,
							user_FinancialStatus: userProfile.user_FinancialStatus,
							user_accounttype: userProfile.user_accounttype,
						};
						if(process.env.REACT_APP_ENVIRONMENT === 'app') {
							let pendo = window.pendo;
							pendo.initialize({
								visitor: {
									id: loginRes.user.userId,
									email: loginRes.user.emailAddress,
									firstName: userProfile.user_firstname,
									lastName: userProfile.user_lastname,
									env: process.env.REACT_APP_ENVIRONMENT,
								},
								account: {
									id: loginRes.user.userId,
									accountName: loginRes.user.emailAddress,
									kycStatus: userProfile.user_KYCstatus,
									financialStatus: userProfile.user_FinancialStatus,
								}
							});
						}
						if(loginRes?.user?.isInfluencer==='1'&&loginResponse?.data?.influencer_request===null){
							navigate('/influncer-enrollment')
						  }else{
							navigate(decodeURIComponent(returnUrl));
						  }
					} else {
						setStatus('There was an error fetching user profile information.');
					}
				} catch (error) {
					setStatus('There was an error fetching user profile information.');
					console.error(error);
				}
				if (process.env.REACT_APP_ENVIRONMENT === 'app') {
					try {
					const userTokenId = loginResponse.user.userTokenId;
					  if (!loginResponse || !loginResponse.user || !loginResponse.user.userTokenId) {
						console.error('Error: userTokenId is not available.');
						return;
					  }
					  if (typeof userTokenId !== 'string') {
						console.error('Error: userTokenId is not a valid string.');
						return;
					  }
				  
					  const parts = userTokenId.split("-");
					  if (parts.length === 0) {
						console.error('Error: userTokenId does not contain hyphens to split.');
						return;
					  }
				  
					  const uid = parts.slice(-1)[0]; 
					  if (!uid || typeof uid !== 'string') {
						console.error('Error: UID is invalid after splitting userTokenId.');
						return;
					  }
				  
					  if (typeof window.dataLayer === 'undefined') {
						console.error('Error: window.dataLayer is not defined.');
						window.dataLayer = []; 
					  }
				  
					  function gtag() {
						window.dataLayer.push(arguments);
					  }
				  
					  gtag('config', 'G-4E3GQHG8ST', {
						user_id: uid,
					  });
					} catch (error) {
					  console.error('Unexpected error during Google Analytics configuration:', error);
					}
				}

				saveAuth(tmpAuth);
				setCurrentUser(tmpAuth.emailAddress);

				try {
					// const profileRes = await getProfile();
					const kycStatus = profileRes?.data?.kyc_status;
					const encodedKycStatus = btoa(kycStatus);
					if (kycStatus) {
						localStorage.setItem('kycStatus', encodedKycStatus);
						const messageWelcome = localStorage.getItem('MessageWelcome');
						if (messageWelcome === null || messageWelcome === 'true') {
							localStorage.setItem('MessageWelcome', 'true');
						}
					}
				} catch (error) {
					console.error(error.message || "An error occurred In Token & Prifile Section");
				}
			} else {
				setStatus(loginRes.message || 'There was an error in the login process.');
			}
		} catch (error) {
			setStatus('There was an error in the login process.');
			console.error(error);
		} finally {
			setLoading(false);
			setDisabled(false);
		}
	};
	return (
		<Modal open={open} {...props}>
			<CMForgotPasswordModal className="center-absolute">
				<CloseButton onClick={handleClose} />
				<div style={{overflow: "hidden"}}>
					<Heading previusPage={'User Confirmation'} />
					<Formik
						initialValues={initialValues}
						validationSchema={loginSchema}
						onSubmit={handleSubmit}>

						{({ errors, touched, status, setStatus,setFieldValue }) => (
							<>
								<CMDivLogin>
									{status &&
										<Alert alertType={ALERT_TYPE.error}>{status}</Alert>
									}
									{currentUser &&
										<Alert alertType={ALERT_TYPE.success}>{currentUser}</Alert>
									}
									<Form className='form' id='SignUp' autoComplete='false'>
										<div className='form-container' >
											Please enter the verification code sent to your email address.
											<InputField
												name='authCode'
												id='authCode'
												placeholder='Verification Code'
												isInvalid={errors.authCode && touched.authCode}
												error={errors.authCode}
												onChange={(e) => {
													setStatus("");
													setFieldValue('authCode', e.target.value); 
												}}
											/>
											<div className='form-container' style={{ textAlign: "center" }}>
												<Button className="buttonTopNone" disabled={loading} type='submit'>Continue</Button>
												<p style={{ marginTop: "15px" }}>Did not receive the code?</p>
												<Button disabled={isButtonDisabled || loading} buttonType={BUTTON_TYPE_CLASSES.TextButton} color="blue" onClick={sendAgain}>
													Send again
												</Button>
												{isButtonDisabled && (
													<p className="countMessage">
														Try again in {countdown} seconds
													</p>
												)}
											</div>

										</div>
									</Form>
								</CMDivLogin>
							</>
						)}

					</Formik>
				</div>
			</CMForgotPasswordModal>

		</Modal>

	);
}

export default ConfirmLogin;